import { useEffect, useState } from "react";
import Navbar from "./components/Navbar";
import Hero from "./components/Hero";
import CategorySection from "./components/CategorySection";
import RecommendedSection from "./components/RecommendedSection";
import FeatureSection from "./components/FeatureSection";
import TimelineSection from "./components/TimelineSection";
import FaqSection from "./components/FaqSection";
import AboutSection from "./components/AboutSection";
import Footer from "./components/Footer";

export default function Home() {
  const [searchQuery, setSearchQuery] = useState("");
  const [activeTag, setActiveTag] = useState("全部");
  const [showTop, setShowTop] = useState(false);

  useEffect(() => {
    const onScroll = () => setShowTop(window.scrollY > 500);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const handleSearch = (keyword: string) => {
    setSearchQuery(keyword);
    setActiveTag("全部");
    document.getElementById("recommend")?.scrollIntoView({ behavior: "smooth" });
  };

  const handleTagChange = (tag: string) => {
    setActiveTag(tag);
    setSearchQuery("");
  };

  return (
    <div className="min-h-screen bg-background-50 font-sans">
      <Navbar />
      <main>
        <Hero onSearch={handleSearch} />
        <CategorySection onSelect={handleSearch} />
        <RecommendedSection
          searchQuery={searchQuery}
          activeTag={activeTag}
          onSearch={setSearchQuery}
          onTagChange={handleTagChange}
        />
        <FeatureSection />
        <TimelineSection />
        <FaqSection />
        <AboutSection />
      </main>
      <Footer />

      {showTop && (
        <button
          onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })}
          className="fixed bottom-6 right-6 z-50 flex h-11 w-11 items-center justify-center rounded-full bg-primary-500 text-white shadow-lg transition-colors hover:bg-primary-600"
          aria-label="返回顶部"
        >
          <i className="ri-arrow-up-line text-xl"></i>
        </button>
      )}
    </div>
  );
}